import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SidebarService } from '../sidebar/sidebar.service';
import { AuthenticationService } from '../../app-okc/shared-gz/services/authentication.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})

export class NavbarComponent implements OnInit {

  user: any;

  constructor(
    public sidebarservice: SidebarService,
    private _auth: AuthenticationService,
    private router: Router,
  ) {
    const vm = this;
    vm._auth.isUserUpdated$.subscribe(value => {
      vm.user = vm._auth.userObj;
    });
  }

  ngOnInit() {
    const vm = this;
    vm.user = vm._auth.userObj;
  }

  onLogout() {
    const vm = this;
    vm._auth.logout();
    vm.router.navigate(['/no-auth/sign-in']);
  }


  toggleSidebar() {
    this.sidebarservice.setSidebarState(!this.sidebarservice.getSidebarState());
  }

  getSideBarState() {
    return this.sidebarservice.getSidebarState();
  }

  hideSidebar() {
    this.sidebarservice.setSidebarState(true);
  }
}
